import {
  GET_TAGGED_MEDIA_SUCCESS,
  PUT_IMAGES_SUCCESS,
  GET_PRESIGNED_URLS_SUCCESS,
} from "../actions/imageActions";

const initialState = {
  images: [],
  putResponse: null, // Add this to hold the response of the putImages action
  presignedUrls: [], // Add this to hold the presigned URLs
};

const imageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TAGGED_MEDIA_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - FETCH_IMAGES_SUCCESS - payload: ${JSON.stringify(
      //     action.payload
      //   )}`,
      //   action.payload
      // );
      return {
        ...state,
        images: action.payload,
      };
    case PUT_IMAGES_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - PUT_IMAGES_SUCCESS - action.payload.result:`,
      //   action
      // );
      return {
        ...state,
        putResponse: action.payload, // Update the state with the put response
      };
    case GET_PRESIGNED_URLS_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - GET_PRESIGNED_URLS_SUCCESS - action.payload:`,
      //   action.payload
      // );
      return {
        ...state,
        presignedUrls: action.payload, // Update the state with the presigned URLs
      };
    default:
      return state;
  }
};

export default imageReducer;
